import { common } from "../../constants/actionTypes";

const addressGetRequest = (data, searchType) => ({
  type: common.ADDRESS_GET_REQUEST,
  data: data,
  searchType: searchType,
});

const countryListGetSuccess = (data) => ({
  type: common.COUNTRY_LIST_GET_SUCCESS,
  data: data,
});

const stateListGetSuccess = (data) => ({
  type: common.STATE_LIST_GET_SUCCESS,
  data: data,
});

const cityListGetSuccess = (data) => ({
  type: common.CITY_LIST_GET_SUCCESS,
  data: data,
});

const commonLoaderRequest = () => ({
  type: common.COMMON_LOADER_GET_REQUEST,
});

const commonLoaderSuccess = () => ({
  type: common.COMMON_LOADER_GET_SUCCESS,
});

const getWebSocketTicket = (payload) => ({
  type: common.GET_WEBSOCKET_TICKET,
  data: payload,
});

const setWebSocketTicket = (ticketData) => ({
  type: common.SET_WEBSOCKET_TICKET,
  data: ticketData,
});

const getNotificationWebSocketTicket = (payload) => ({
  type: common.GET_NOTIFICATION_WEBSOCKET_TICKET,
  data: payload,
});

const setNotificationWebSocketTicket = (ticketData) => ({
  type: common.SET_NOTIFICATION_WEBSOCKET_TICKET,
  data: ticketData,
});

const clearSocketTicket = (ticketData) => ({
  type: common.CLEAR_TICKET,
  data: ticketData,
});
const getDashboardSocketTicket = (payload) => ({
  type: common.GET_DASHBOARD_WEBSOCKET_TICKET,
  data: payload,
});

const setDashboardWebSocketTicket = (ticketData) => ({
  type: common.SET_DASHBOARD_WEBSOCKET_TICKET,
  data: ticketData,
});
const setIsDarkTheme = (isDarkTheme) => ({
  type: common.SET_IS_DARK_THEME,
  data: isDarkTheme,
});

const setSideBarCollapse = (collapsed) => ({
  type: common.SET_IS_SIDEBAR_COLLAPSE,
  data: collapsed,
});

const setSideBarHidden = (hidden) => ({
  type: common.SET_IS_SIDEBAR_HIDDEN,
  data: hidden,
});

export {
  addressGetRequest,
  countryListGetSuccess,
  stateListGetSuccess,
  cityListGetSuccess,
  commonLoaderRequest,
  commonLoaderSuccess,
  getWebSocketTicket,
  setWebSocketTicket,
  getNotificationWebSocketTicket,
  setNotificationWebSocketTicket,
  clearSocketTicket,
  getDashboardSocketTicket,
  setDashboardWebSocketTicket,
  setIsDarkTheme,
  setSideBarCollapse,
  setSideBarHidden,
};
